declare global {
  interface Window {
    fbq?: {
      (...args: unknown[]): void
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[][]
      loaded?: boolean
      version?: string
      push?: (...args: unknown[]) => void
    }
    _fbq?: Window['fbq']
  }
}

const PIXEL_ID = '896179340192256'

export function initializeMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: NonNullable<Window['fbq']> = (...args: unknown[]) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }

    fbq.queue?.push(args)
  }

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = (...args: unknown[]) => fbq(...args)

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function trackMetaEvent(eventName: 'PageView' | 'AddToCart') {
  window.fbq?.('track', eventName)
}
